module.exports = __webpack_public_path__ + "img/RKey.460b5e2d.png";